<template>
  <BaseSideBar>
    <SideBarTitle
      :title="$t('sideBar.cart.title')"
      mode="cart"
      iconName="mdi-cart-outline"
      class="cart-title"
      :isSideBarTitleShown="!needToCloseSideBar"
    />
  </BaseSideBar>
</template>

<script>
import BaseSideBar from "./BaseSideBar.vue";
import SideBarTitle from "./SideBarTitle.vue";

export default {
  components: {
    BaseSideBar,
    SideBarTitle,
  },
  data() {
    return {};
  },
  computed: {
    isLangHebrew() {
      return this.getUserLang == "he" ? true : false;
    },
    needToCloseSideBar() {
      if (
        (this.$store.getters.isMobile || this.$store.getters.isTablet) &&
        !this.$store.state.openMenu
      ) {
        // this.$store.commit("toggleMenu");
        return true;
      } else {
        return false;
      }
    },
    getParamStatus() {
      return this.$route.params.status;
    },
  },
};
</script>

<style lang="scss">
.cart-title {
  h2 {
    margin: 0 !important;
  }
}
</style>
